(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-validate/assets/javascript/components/page-wrapper.js') >= 0) return;  svs.modules.push('/modules/tickets-validate/assets/javascript/components/page-wrapper.js');
"use strict";


const {
  Grid
} = svs.ui.ReactGrid;
setGlobal('svs.ticketsValidate.components.PageWrapper', _ref => {
  let {
    children,
    className = ''
  } = _ref;
  return React.createElement(Grid, null, React.createElement("div", {
    className: "align-center validate-tickets-page f-body ".concat(className, " padding-h-1 padding-top-3")
  }, children));
});

 })(window);